import { useCallback, useEffect } from "react";

import { GetBGMgr, GetWSMgr } from "@/Utils/StateLib";
import { useRouteState } from "@/hooks/useRouteState";
import { useTopic } from "@/hooks/useTopic";
import { enumBGOption } from "@coreapp/constants";

/** Syncs ?background= URL param to coreapp on param change and document load. */
export const useBackgroundSync = () => {
  const { background: backgroundParam } = useRouteState();

  const applyBackground = useCallback(() => {
    if (backgroundParam == null) return;
    const wsMgr = GetWSMgr();
    const doc = wsMgr?.GetDoc();
    if (!wsMgr || !doc) return;
    const iWizData = doc.GetIWizData?.();
    if (!iWizData) return;

    if (backgroundParam === "None") {
      iWizData.SetMasterOption(enumBGOption.custom);
      GetBGMgr()?.ClearActiveBackground();
    } else {
      iWizData.SetMasterFolder("Masters");
      iWizData.SetMasterFile(backgroundParam);
      iWizData.SetMasterOption(enumBGOption.linked);
    }
    wsMgr.ApplyBackground();
  }, [backgroundParam]);

  // Re-apply when a new document loads (deep link, cross-chart nav, file-manager open)
  useTopic("chartDocumentLoaded", applyBackground);

  // Apply when the URL param changes (back/forward nav, picker)
  useEffect(applyBackground, [applyBackground]);
};
